import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export type BlockTheme = 'basic';
export type WhiteSize = 'micro' | 'small' | 'medium' | 'large';
export type DefaultBoard = 'orange' | 'blue';

type BoardEditorConfigState = {
    isDark: boolean;
    isAIWhiteEnabled: boolean;
    blockTheme: BlockTheme;
    whiteSize: WhiteSize;
    defaultBoard: DefaultBoard;
    hasHydrated: boolean;
    toggleTheme: () => void;
    toggleAIWhite: () => void;
    setBlockTheme: (theme: BlockTheme) => void;
    setWhiteSize: (size: WhiteSize) => void;
    setDefaultBoard: (board: DefaultBoard) => void;
    setHasHydrated: (hydrated: boolean) => void;
};

export const useBoardEditorConfigStore = create<BoardEditorConfigState>()(
    persist(
        (set) => ({
            isDark: false,
            isAIWhiteEnabled: true,
            blockTheme: 'basic',
            whiteSize: 'large',
            defaultBoard: 'orange',
            hasHydrated: false,
            toggleTheme: () => set((state) => ({ isDark: !state.isDark })),
            toggleAIWhite: () => set((state) => ({ isAIWhiteEnabled: !state.isAIWhiteEnabled })),
            setBlockTheme: (theme) => set({ blockTheme: theme }),
            setWhiteSize: (size) => set({ whiteSize: size }),
            setDefaultBoard: (board) => set({ defaultBoard: board }),
            setHasHydrated: (hydrated) => set({ hasHydrated: hydrated }),
        }),
        {
            name: 'KEY-BOARD-EDITOR-CONFIG',
            storage: typeof window !== 'undefined' ? createJSONStorage(() => localStorage) : undefined,
            onRehydrateStorage: () => (state, error) => {
                if (error) return;
                if (state) state.setHasHydrated(true);
            },
        },
    ),
);
